import React from 'react';
import BoardRow from './boardRow';
import Config from './modules/config';
import SgfUtil from './modules/sgf/sgfUtil';

function classify(props) {
  if (!props.prediction
    || !props.prediction.visits.length
    || !props.prediction.evaluations.length
    || !props.boardModel) {
    return undefined;
  }
  const rank = Array(props.boardModel.boardSize ** 2).fill(0);
  if (props.viewMode !== "visits") {
    return rank;
  }
  // find max value
  const visits = props.prediction.visits;
  const evaluations = props.prediction.evaluations;
  let sum = visits.reduce((a, b) => a + b);
  if (sum > 0) {
    const bestMoveIndex = props.prediction.bestMoveIndex || 0;
    if (bestMoveIndex) {
      rank[bestMoveIndex] = 1;
    }
    const hideLessVisits = Config.getInstance().hideLessVisits;
    const maxEvaluation = evaluations[bestMoveIndex] + 1.0; // 0 - 2.0
    visits.forEach((visit, index) => {
      if (rank[index] === 0 && visits[index] > 0) {
        const evaluation = evaluations[index] + 1.0;
        if (visit >= sum * 0.2 || 
          (visit >= sum * 0.03 && evaluation >= maxEvaluation * 0.98)) {
          rank[index] = 2;
        } else if (visit >= sum * 0.1 || 
          (visit >= sum * 0.02 && evaluation >= maxEvaluation * 0.96)) {
          rank[index] = 3;
        } else if (visit >= sum * 0.05 || 
          (visit >= sum * 0.01 && evaluation >= maxEvaluation * 0.94)) {
          rank[index] = 4;
        } else if ((visit >= sum * 0.025 && evaluation >= maxEvaluation * 0.92)
          || (!hideLessVisits && visit > 0)) {
          rank[index] = 5;
        }
      }
    });
  }
  return rank;
}

function getVariationLetters(props, boardSize) {
  const letters = Array(boardSize ** 2);
  if (!props.prediction || props.viewMode !== "variation"
    || (props.variationMoves && props.variationMoves.length)) {
    return letters;
  }
  const variations = props.prediction.variations;
  const num = Config.getInstance().numOfVariations;
  variations.filter((_, i) => i < num)
    .forEach((variation, i) => {
      if (variation.visit > 0) {
        letters[variation.index] = String.fromCharCode(65 + i);
      }
    });
  return letters;
}

function playVariationMoves(props) {
  let boardModel = props.boardModel;
  let moveNumbers = props.moveNumbers;
  if (props.viewMode === "variation" && props.boardModel
    && props.variationMoves && props.variationMoves.length) {
    boardModel = boardModel.clone();
    const moves = props.variationMoves.slice();
    const boardSize = boardModel.boardSize;
    moveNumbers = Array(boardSize ** 2).fill().map(() => []);
    let moveNumber = 1;
    while (moves.length) {
      const move = moves.shift();
      const index = SgfUtil.vertexToIndex(move, boardSize);
      boardModel.move(index);
      moveNumbers[index].push(moveNumber);
      moveNumber++;
    }
  }
  return [boardModel, moveNumbers];
}

function Board(props) {
  const boardSize = props.boardModel ? props.boardModel.boardSize : 19;
  const rank = classify(props);
  const variationLetters = getVariationLetters(props, boardSize);
  const [boardModel, moveNumbers] = playVariationMoves(props);
  const rows = Array(boardSize).fill().map(
    (_, i) =>
      <BoardRow
        key={i}
        row={i}
        boardSize={boardSize}
        width={props.squareWidth}
        height={props.squareHeight}
        fontSize={props.fontSize}
        boardModel={boardModel}
        prediction={props.prediction}
        variationLetters={variationLetters}
        variationMoves={props.variationMoves}
        moveNumber={props.moveNumber}
        moveNumbers={moveNumbers}
        rank={rank}
        viewMode={props.viewMode}
        onClick={props.onClick}
      />
  );

  return (
    <div className="board">
      {rows}
    </div>
  );
}

export default Board;